import { OrderStatus } from '../../../../../../graphql/order/models';

export const isOrderClosed = (status?: OrderStatus) => {
  return status === OrderStatus.canceled
    || status === OrderStatus.canceledByPatient
    || status === OrderStatus.canceledAutomatically
    || status === OrderStatus.fulfilled;
};

export const getIsFulfilledOrder = (status?: OrderStatus) => {
  return status === OrderStatus.fulfilled;
};
